import { render } from "./RedButton.vue?vue&type=template&id=3e2e64fc&scoped=true"
import script from "./RedButton.vue?vue&type=script&lang=js"
export * from "./RedButton.vue?vue&type=script&lang=js"

import "./RedButton.vue?vue&type=style&index=0&id=3e2e64fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2e64fc"]])

export default __exports__